import React, { useState } from 'react';
import { PostLoginWrapper } from './PostLoginWrapper';
import { clearAuthSession } from '../authSession';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

export const UpdateUser = () => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [linkCode, setLinkCode] = useState('');
  const [expiresAt, setExpiresAt] = useState('');
  const [instruction, setInstruction] = useState('');
  const [copied, setCopied] = useState(false);

  const refreshAccessToken = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) return null;

      const response = await fetch('/vitisad/refresh_token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken })
      });

      if (!response.ok) return null;
      const data = await response.json();
      return data.accessToken || null;
    } catch (err) {
      return null;
    }
  };

  const generateLinkCode = async () => {
    setError('');
    setCopied(false);
    setIsLoading(true);

    try {
      let accessToken = localStorage.getItem('accessToken');
      if (!accessToken) {
        setError('No hay sesion activa');
        setIsLoading(false);
        return;
      }

      let response = await fetch('/vitisad/whatsapp/link-code', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`
        }
      });

      if (response.status === 401) {
        const newAccessToken = await refreshAccessToken();
        if (!newAccessToken) {
          clearAuthSession();
          setError('Tu sesion ha expirado. Vuelve a iniciar sesion.');
          setIsLoading(false);
          return;
        }

        localStorage.setItem('accessToken', newAccessToken);
        accessToken = newAccessToken;

        response = await fetch('/vitisad/whatsapp/link-code', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        });
      }

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'No se pudo generar el codigo');
        return;
      }

      setLinkCode(data.code || '');
      setExpiresAt(data.expires_at || '');
      setInstruction(data.instruction || '');
    } catch (err) {
      setError('Error de conexion al generar el codigo');
    } finally {
      setIsLoading(false);
    }
  };

  const copyInstruction = async () => {
    if (!instruction) return;
    try {
      await navigator.clipboard.writeText(instruction);
      setCopied(true);
    } catch (err) {
      setError('No se pudo copiar al portapapeles');
    }
  };

  return (
    <PostLoginWrapper error={error}>
      <div className="w-11 flex flex-column align-items-center" style={{ marginTop: '30px' }}>
        <div className="w-full" style={{ maxWidth: '560px' }}>
          <h2 style={{ marginBottom: '0.5rem' }}>Perfil</h2>
          <p style={{ marginTop: 0, color: '#6b7280' }}>
            Vincula tu WhatsApp para hablar con Vitisad desde el telefono.
          </p>

          <div className="flex flex-column gap-3" style={{ marginTop: '1rem' }}>
            <Button
              label={isLoading ? 'Generando...' : 'Generar codigo de vinculacion'}
              onClick={generateLinkCode}
              disabled={isLoading}
              className="w-full"
            />

            <label htmlFor="link-code" style={{ fontWeight: 600 }}>Codigo</label>
            <InputText
              id="link-code"
              value={linkCode}
              readOnly
              placeholder="Pulsa en generar codigo"
              className="w-full"
            />

            {instruction ? (
              <>
                <label htmlFor="instruction" style={{ fontWeight: 600 }}>Mensaje para WhatsApp</label>
                <InputText
                  id="instruction"
                  value={instruction}
                  readOnly
                  className="w-full"
                />
                <Button
                  label={copied ? 'Copiado' : 'Copiar mensaje'}
                  onClick={copyInstruction}
                  outlined
                  className="w-full"
                />
              </>
            ) : null}

            {expiresAt ? (
              <small style={{ color: '#6b7280' }}>
                Caduca: {expiresAt}
              </small>
            ) : null}
          </div>
        </div>
      </div>
    </PostLoginWrapper>
  );
};
